var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatermark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240.656,
    height: 86.141,
    viewBox: "0 0 240.656 86.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-7334.5 -3926.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17944",
    "data-name": "Path 17944",
    d: "M274.262,123.138h110.85l-12.465,24.047a14.718,14.718,0,0,1-13,8.173H257.578Z",
    transform: "translate(7190.044 3857.702)",
    fill: "#85e6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17945",
    "data-name": "Path 17945",
    d: "M167.368,94.872h66.51L226.4,109.183a8.841,8.841,0,0,1-7.8,4.862h-61.24Z",
    transform: "translate(7246.444 3873.609)",
    fill: "none",
    stroke: "#517ce3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.816
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17946",
    "data-name": "Path 17946",
    d: "M40.587,36.111h60.469l-6.8,13.152a8.029,8.029,0,0,1-7.094,4.471H31.486Z",
    transform: "translate(7317.281 3906.678)",
    fill: "#6d44e5",
    opacity: 0.321
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17947",
    "data-name": "Path 17947",
    d: "M239.666.96h87.878l-9.881,19.081a11.668,11.668,0,0,1-10.308,6.484H226.44Z",
    transform: "translate(7207.567 3926.46)",
    fill: "none",
    stroke: "#85e6c4",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.622
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17948",
    "data-name": "Path 17948",
    d: "M80.986,145.547h25.8l-2.9,5.611a3.427,3.427,0,0,1-3.027,1.907H77.1Z",
    transform: "translate(7291.609 3845.091)",
    fill: "#517ce3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    x2: 11.954,
    transform: "translate(7335 3942.789)",
    fill: "none",
    stroke: "#85e6c4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    x2: 26.258,
    transform: "translate(7503.933 3968.481)",
    fill: "none",
    stroke: "#6d44e5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermark);
export default __webpack_public_path__ + "static/media/watermark.fd4b7cbcaaf4878ea8912a3eb211b463.svg";
export { ForwardRef as ReactComponent };